import { createStaticRanges } from 'react-date-range';

export const useCustomRangePresets = () => createStaticRanges([]); // Add new static ranges if needed
